import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Welcome } from "./pages/Welcome";
import { Home } from "./pages/Home";
import { Admin } from "./pages/Admin";
import { Privacy } from "./pages/Privacy";
import { Restaurant } from "./pages/Restaurant";
import SpecialPage from "./pages/SpecialPage";
import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Welcome />} />
          <Route path="/plats" element={<Home />} />
          <Route path="/restaurant/:id" element={<Restaurant />} />
          <Route path="/fete/:slug" element={<SpecialPage />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/confidentialite" element={<Privacy />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
